import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { SelectChangeEvent } from '@mui/material/Select';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize } from '../../theme';
import { SelectFilterStyled, MenuItemStyled, StyledSelectFormControl } from './styled';
import { HEADER_TYPE } from './type';

type FilterDropdownProps = {
    columnId: string
    selectedFilterValues?: string[]
    handleSelectedFilterValues: (property: string, filterValues: string[], filterType: HEADER_TYPE) => void
    filterValues?: string[]
}

export default function FilterDropdown(props: FilterDropdownProps) {
    const { columnId, selectedFilterValues, handleSelectedFilterValues, filterValues } = props;
    const [actualFilterValues, setActualFilterValues] = React.useState<string[]>(selectedFilterValues || []);
    const [openFilterSelect, setOpenFilterSelect] = useState(false);
    const { t } = useTranslation('dashboard');

    const handleChange = (event: SelectChangeEvent<typeof actualFilterValues>) => {
        const {
            target: { value },
        } = event;
        if (value.includes('null')) {
            setActualFilterValues([]);
        } else {
            setActualFilterValues(typeof value === 'string' ? value.split(',') : value);
            handleSelectedFilterValues(columnId, typeof value === 'string' ? value.split(',') : value, HEADER_TYPE.CHOICE);
        }
    };

    const closeSelectFilter = (e: React.ChangeEvent) => {
        const targetRole = e.target.getAttribute('role');
        if (targetRole === 'option' && e.target.getAttribute('data-value') !== 'null') {
            setOpenFilterSelect(true);

            return;
        }
        if (targetRole === 'option' && e.target.getAttribute('data-value') === 'null') {
            setOpenFilterSelect(false);
            handleSelectedFilterValues(columnId, [], HEADER_TYPE.CHOICE);

            return;
        }
        if (targetRole === 'button') {
            setOpenFilterSelect(true);

            return;
        }

        setOpenFilterSelect(false);
    };

    return (
        <StyledSelectFormControl sx={{ m: 1, minWidth: 180, margin: '0px' }}>
            <SelectFilterStyled
                IconComponent={ArrowDropDownRoundedIcon}
                id="hot-alert-filter-select"
                labelId="hot-alert-filter-select"
                onChange={handleChange}
                onClick={closeSelectFilter}
                onOpen={() => setOpenFilterSelect(true)}
                open={openFilterSelect}
                renderValue={(selected: Array<string>) => {
                    if (actualFilterValues.length === 0) {
                        return t('filter.selectFilter');
                    }

                    return selected
                        .map((name) => name)
                        .join(', ');
                }}
                sx={actualFilterValues.length > 0 ? { color: colors.grey100 } : { color: colors.grey1500 }}
                value={actualFilterValues}
                variant="standard"
                displayEmpty
                multiple
            >
                <MenuItemStyled sx={{ fontSize: fontSize.sm, color: colors.grey400, fontStyle: 'italic' }} value='null' disableRipple>
                    {t('filter.noFilter')}
                </MenuItemStyled>
                {filterValues && filterValues.map((name) => (
                    <MenuItemStyled
                        key={name}
                        value={name}
                        disableRipple
                    >
                        {name}
                    </MenuItemStyled>
                ))}
            </SelectFilterStyled>
        </StyledSelectFormControl>
    );
}
